module.exports = __webpack_public_path__ + "static/safdie-b99d06a8ebf5ce17e522748142a4f173.jpg";